import React, { useEffect, useState } from 'react';
import api, { uploadsBaseUrl } from '../../api';
import { Link } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';

function ArticleList() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  const [articles, setArticles] = useState([]);

  const fetchArticles = async () => {
    const res = await api.get('/articles');
    setArticles(res.data);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const deleteArticle = async id => {
    if (window.confirm('Delete this article?')) {
      await api.delete(`/articles/${id}`);
      fetchArticles();
    }
  };

  return (
    <DashboardLayout>
      <div className="grid-container" style={{ backgroundColor: 'transparent' }}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">All Articles</h2>
          <Link to="/articles/new" className="bg-green-600 text-white px-3 py-1 rounded">
            New Article
          </Link>
        </div>

        {articles.map(article => (
          <div key={article.id} className="border p-4 mb-4 rounded shadow">
            <img
              src={`${uploadsBaseUrl}/${article.mainImage}`}
              alt={article.title}
              className="w-48 mb-2 rounded"
            />
            <h3 className="text-lg font-semibold">{article.title}</h3>
            <p className="text-sm text-gray-600 mb-2">{article.category}</p>
            <div className="flex gap-2">
              <Link to={`/edit/${article.id}`} className="bg-blue-600 text-white px-3 py-1 rounded">
                Edit
              </Link>
              <button
                className="bg-red-600 text-white px-3 py-1 rounded"
                onClick={() => deleteArticle(article.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}

export default ArticleList;
